<template>
  <Button type="link" variant="black" icon="general.copyFileFolder" data-testid="viewer-transcription-copy" @click.prevent="copy()">Copy transcription</Button>
</template>

<script setup lang="ts">
import { Ref, watch } from 'vue';
import { storeToRefs } from 'pinia';
import { useClipboard } from '@vueuse/core';

import { Button } from '@/storybook';
import { useToast } from '@/composables/useToast';
import { TrackEvents, useTrack } from '@/composables/useTrack';
import { useTranscriptionStore } from '@/modules/viewer/store/useTranscriptionStore';

const { success } = useToast();
const { trackItemOwner } = useTrack();
const transcriptionStore = useTranscriptionStore();
const { transcriptionTranscript: transcript } = storeToRefs(transcriptionStore);
const { copy, copied } = useClipboard({ source: transcript as Ref });

watch(copied, res => {
  if (!res) {
    return;
  }
  trackItemOwner(TrackEvents.VIEWER_TRANSCRIPTION_COPY);
  success('Transcription copied to clipboard', { icon: 'general.copy' });
});
</script>
